export default __webpack_public_path__ + "static/media/6.b70b87a0.svg";